export default "__VITE_ASSET__BR2enHCn__"